import Spacer from '../Spacer/Spacer.jsx';
import React from 'react';

import {Swiper, SwiperSlide} from 'swiper/react';
import '../../styles/styles.scss';
import styles from './SliderBannerDots.module.scss';
import {getBaseImagePath} from '../../../../ui/catalog/Utils';

import {Autoplay, Pagination} from 'swiper/modules';

const SliderBannerDots = (props) => {
	const slides = props.params.sliderDots || [];

	return (
		<>
			<div className="carousel-container sliderBanner sliderBanner__sm">
				<Swiper
					grabCursor={true}
					centeredSlides={false}
					slidesPerView={1}
					loop={true}
					speed={400}
					spaceBetween={0}
					modules={[Autoplay, Pagination]}
					pagination={{
						clickable: true,
						el: '.bullet-pag',
						renderBullet: function(index, className) {
							return `<span class="${className} bullet-pag-elem"></span>`;
						},
					}}
					autoplay={{
						delay: 5000,
					}}
				>
					{slides.map((slide, i) => {
						return (
							<SwiperSlide key={i}>
								<a href={slide.url}>
									<img
										className={styles.slide}
										src={getBaseImagePath() + slide.img}
										alt={slide.img}
									/>
								</a>
							</SwiperSlide>
						);
					})}
					<div className="bullet-pag"></div>
				</Swiper>
			</div>
			<Spacer />
		</>
	);
};

export default SliderBannerDots;